import { useEffect, useState } from "react";
import { GoCheckCircle } from "react-icons/go";
import { IoAlertCircleOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import "./Modal.scss";



const setIconColor = ({ danger, warning, warn, info }) => {

    if (danger) {
        return "danger";
    } else if (warning) {
        return "warning";
    } else if (warn) {
        return "warn";
    } else if (info) {
        return "info";
    } else {
        return "";
    }
}

const Modal2 = ({ onClose = () => { }, type, danger, info, warning, children }) => {
    const HandleClose = (e) => {
        if (e.keyCode === 27 || e.keyCode === 13) {
            window.removeEventListener("keyup", HandleClose);
            onClose();
        }
    };
    window.addEventListener("keyup", HandleClose);
    const { t } = useTranslation(["page"]);

    return (
        <>
            <div className={`modal2 ${type} ${setIconColor({ danger, warning, info })}`}>
                <div className="modalWrap">
                    <div className="modalCon">
                        <h2><GoCheckCircle /></h2>
                        <div className="conText">{children}{/* 텍스트 */}</div>
                        <div className="btnBox">
                            <button className="okBtn" onClick={onClose}>
                                {t("확인")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg" onClick={onClose}></div>
        </>
    )
}

const ModalWarning = ({ onClose = () => { }, type, danger, info, warning, children }) => {
    const HandleClose = (e) => {
        if (e.keyCode === 27 || e.keyCode === 13) {
            window.removeEventListener("keyup", HandleClose);
            onClose();
        }
    };
    window.addEventListener("keyup", HandleClose);
    const { t } = useTranslation(["page"]);

    return (
        <>
            <div className={`modal2 ${type} ${setIconColor({ danger, warning, info })}`}>
                <div className="modalWrap">
                    <div className="modalCon">
                        <h2><IoAlertCircleOutline /></h2>
                        <div className="conText">{children}{/* 텍스트 */}</div>
                        <div className="btnBox">
                            <button className="okBtn" onClick={onClose}>
                                {t("확인")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg" onClick={onClose}></div>
        </>
    )
}

const Confirm2 = ({ onClose = () => { }, children, type, isDisabled = false, autoComplete = true, onConfirm = () => { }, danger, info, warning, valid = () => true }) => {
    const { t } = useTranslation(["page"]);
    const HandleConfirm = (e) => {
        if (e.keyCode === 13 && e.target.tagName.toUpperCase() !== "TEXTAREA") {
            _confirm();
        } else if (e.target.tagName.toUpperCase() === "TEXTAREA") {
            window.removeEventListener("keyup", HandleConfirm);
        }
    };
    const HandleClose = (e) => {
        if (e.keyCode === 27) {
            window.removeEventListener("keyup", HandleClose);
            onClose();
        }
    };

    if (autoComplete) {
        window.addEventListener("keyup", HandleConfirm);
        window.addEventListener("keyup", HandleClose);
    }
    const _confirm = () => {
        if (valid() && !isDisabled) {
            window.removeEventListener("keyup", HandleConfirm);
            onClose(true);
            onConfirm();
        }
    };

    return (
        <>
            <div className={`confirm2 ${type} ${setIconColor({ danger, warning, info })}`}>
                <div className="confWrap">
                    <div className="confCon">
                        <h2><IoAlertCircleOutline /></h2>
                        <div className="conText">{children}</div>

                        <div className="btnBox">
                            <button className="noBtn" onClick={onClose}>{t("cancel")}</button>
                            <button className="okBtn" disabled={isDisabled} onClick={_confirm}>{t("confirm")}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg" onClick={onClose}></div>
        </>
    )

}

const ConfirmMessage = ({
                            onClose,
                            autoComplete = true,
                            message = "Message", onConfirm, children,
                            danger, info, warning, type,
                            invalidMessage = 'Type Message',
                            isDisabled = false,
                        }) => {
    const { t } = useTranslation(["page"]);

    const [ConfirmMessage, SetConfirmMessage] = useState("");
    const [ExceptionMessage, SetExceptionMessage] = useState(false);

    const HandleKeyBind = (e) => {
        if (
            e.target.tagName.toUpperCase() !== "TEXTAREA" ||
            e.target.tagName.toUpperCase() !== "INPUT"
        ) {
            if (e.keyCode === 13) {
                _confirm();
            }
            if (e.keyCode === 27) {
                onClose();
            }
        }
    };
    useEffect(() => {
        if (autoComplete) {
            document.addEventListener("keyup", HandleKeyBind);
        }
        return () => {
            document.removeEventListener("keyup", HandleKeyBind);
        };
    }, []);
    const _confirm = () => {
        if (ConfirmMessage) {
            onClose();
            !isDisabled && onConfirm(ConfirmMessage);
        } else {
            SetExceptionMessage(true);
        }
    };

    return (
        <>
            <div className={`confirm2 ${type} ${setIconColor({ danger, warning, info })}`}>
                <div className="confWrap">
                    <div className="confCon">
                        <h2><IoAlertCircleOutline /></h2>
                        <div className="conText">{children && children}</div>
                        <textarea
                            value={ConfirmMessage}
                            onChange={(e) => SetConfirmMessage(e.target.value)}
                            onFocus={() => SetExceptionMessage(false)} placeholder={message}
                        />
                        {ExceptionMessage && (
                            <span className={"exception invalid"}>{t(invalidMessage)}</span>
                        )}
                        <div className="btnBox">
                            <button className="noBtn" onClick={onClose}>{t("cancel")}</button>
                            <button className="okBtn" onClick={_confirm} disabled={isDisabled}>{t("confirm")}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg" onClick={onClose}></div>
        </>
    )
}
export { Modal2, Confirm2, ConfirmMessage, ModalWarning };
